import { useQuery } from "@tanstack/react-query";
import { request } from "@/lib/coachQueries";

/**
 * Master v5 Prompt 17 — Client 360's coach-only, member-scoped read
 * models (client_record_routes.py). One hook per tab — each tab only
 * loads its own data when actually opened.
 */
function useClientRecordTab(tab, workspaceId, memberId) {
  return useQuery({
    queryKey: ["client-record", tab, workspaceId, memberId],
    enabled: !!workspaceId && !!memberId,
    queryFn: () => request(`/api/rehearsal-room/workspaces/${workspaceId}/client-record/${memberId}/${tab}`),
  });
}

export const useClientRecordOverview = (w, m) => useClientRecordTab("overview", w, m);
export const useClientRecordTimeline = (w, m) => useClientRecordTab("timeline", w, m);
export const useClientRecordSessions = (w, m) => useClientRecordTab("sessions", w, m);
export const useClientRecordCoachingReview = (w, m) => useClientRecordTab("coaching-review", w, m);
export const useClientRecordPractice = (w, m) => useClientRecordTab("practice", w, m);
export const useClientRecordFiles = (w, m) => useClientRecordTab("files", w, m);
export const useClientRecordMessages = (w, m) => useClientRecordTab("messages", w, m);
export const useClientRecordReviews = (w, m) => useClientRecordTab("reviews", w, m);
export const useClientRecordRecommendations = (w, m) => useClientRecordTab("recommendations", w, m);
